import React from 'react'
import { CustomInputTypes } from './CustomInput.enum'
import SelectInput from '../select/SelectInput'
import TextInput from '../input/textInput'
import DatePickerInput from '../date-picker/DatePickerInput'
import SwitchInput from '../switch/SwitchInput'

export type Props = {
  form: any
  rules?: any[]
  label: string
  name: string
  onChange?: any
  inputProps?: any
  hasFeedback?: any
  mode?: 'multiple' | 'default'
  required?: boolean
  render?: () => React.ReactElement
  title?: string
  subtitle?: string
  isChecked?: boolean
  locale?: {
    yesOption: string
    notOption: string
  }
}

type IProps = {
  type?: CustomInputTypes
  props: Props
}

const CustomInput: React.FC<IProps> = ({ type = CustomInputTypes.TextInput, props }) => {
  const InputsTypes: any = {
    [CustomInputTypes.TextInput]: () => <TextInput {...props} />,
    [CustomInputTypes.SelectInput]: () => <SelectInput {...props} />,
    // eslint-disable-next-line react/prop-types
    [CustomInputTypes.DateInput]: () => <DatePickerInput {...props} />,
    [CustomInputTypes.SwitchInput]: () => <SwitchInput {...props} />,
  }

  return InputsTypes[type] ? InputsTypes[type]() : null
}

export default CustomInput
